import { useApiPrivateRequest } from "../../../shared/hooks/useApi";

export const useSuggestQuestions = (chatId: string) => {
  const { data: suggestedQuestions, call } = useApiPrivateRequest<string[]>(
    (response) => response,
  );
  const suggestQuestions = async () => {
    await call(`/chats/${chatId}/suggestQuestions`, "POST", undefined, {});
  };

  return {
    newSuggestedQuestions: suggestedQuestions,
    suggestQuestions,
  };
};
